export const calendarsReducer = (state = {loading: true, resultcalendar: null, calendars: [], calendar: null } , action) => {
    switch (action.type) {
        case 'CALENDAR_GETALL_SUCCESS':
            return {
                ...state,
                loading: false,
                calendars: action.payload
            }
        case 'CALENDAR_GET_SUCCESS':
            return {
                ...state,
                loading: false,
                calendar: action.payload
            }
        case 'CALENDAR_ADD_SUCCESS':
            return {
                ...state,
                loading:false,
                calendars: [...state.calendars, action.payload.calendars],
                resultcalendar: action.payload.message
            }
        case 'CALENDAR_EDIT_SUCCESS':
            return {
                ...state,
                loading:false,
                resultcalendar: action.payload
            }
        case 'CALENDAR_RESET_RESULT':
            return {...state,
                resultcalendar: null
            }
        case 'CALENDAR_RESET':
            return {...state,
                calendars: [],
                loading: true
            }
        case 'CALENDAR_LOADING':
            return {
                ...state,
                loading:true
            }
        case 'CALENDAR_NOT_LOADING':
            return {
                ...state,
                loading:false
            }
        case 'CALENDAR_REMOVE_RESULT':
            return {...state,
                loading:false,
                resultcalendar: action.payload.message,
                calendars: state.calendars.filter(calendars => calendars._id !== action.payload.calendar)
            }
        default:
            return state
    }
}

